<div class="page">
  <div class="asset-container" *ngIf="asset">
    <img [src]="asset | assetUrl : asset.version_data.watermark_uuid : 160 | async" alt="" class="asset" />
    <div class="icon">
      <app-svg src="/assets/icons/cross-circle.svg"></app-svg>
    </div>
  </div>

  <h1>Unsubscribed!</h1>

  <p>
    You have now unsubscribed and wont get new updates for this asset going forward. Did you unsubscribe by mistake?
  </p>

  <a
    appButton
    name="resubscribe"
    location="unsubscribe-from-asset-page"
    color="primary"
    size="3"
    height="4"
    spacing="5"
    [routerLink]="'/gallery/' + galleryId + '/subscribe/' + assetId"
    [center]="true"
    >Resubscribe</a
  >

  <div class="extra" *ngIf="additionalAssetCount > 0">
    <span>You’re subscribed to {{ additionalAssetCount }} other assets from this gallery.</span>
    <a [routerLink]="['../']" class="primary-link">Unsubscribe All</a>
  </div>
</div>
